import { defaultAvatarColor, hexToRgba } from '../utils/avatarColors';

// Shows a user's uploaded photo, or a colored initials badge as a fallback.
// The badge color is the user's chosen `color` ("#RRGGBB"), or a deterministic
// palette color derived from `seed` (the user id) when no color is set — kept
// identical to iOS so the same user looks the same on every client.
function initials(name) {
    if (!name) return '?';
    return name
        .split(' ')
        .map((w) => w[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
}

export default function Avatar({ name, url, color, seed, size = 40, className = '' }) {
    const dimension = { width: size, height: size };

    if (url) {
        return (
            <img
                src={url}
                alt={name || 'avatar'}
                style={dimension}
                className={`rounded-full object-cover bg-gray-100 ${className}`}
            />
        );
    }

    const badgeColor = color || defaultAvatarColor(seed);

    return (
        <div
            style={{
                ...dimension,
                fontSize: size * 0.4,
                backgroundColor: hexToRgba(badgeColor, 0.2),
                color: badgeColor,
            }}
            className={`rounded-full flex items-center justify-center font-semibold ${className}`}
        >
            {initials(name)}
        </div>
    );
}
